import type { PlaylistState } from './playlistTypes';
import {
  PLAYLIST_FETCH_REQUEST, PLAYLIST_FETCH_SUCCESS, PLAYLIST_FETCH_FAILURE,
  PLAYLIST_ADD, PLAYLIST_UPDATE, PLAYLIST_DELETE,
} from './playlistTypes';

const initialState: PlaylistState = {
  items: [],
  loading: false,
  error: null,
};

export function playlistReducer(state = initialState, action: any): PlaylistState {
  switch (action.type) {
    case PLAYLIST_FETCH_REQUEST:
      return { ...state, loading: true, error: null };
    case PLAYLIST_FETCH_SUCCESS:
      return { ...state, loading: false, items: action.payload };
    case PLAYLIST_FETCH_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case PLAYLIST_ADD:
      return { ...state, items: [action.payload, ...state.items] };
    case PLAYLIST_UPDATE: {
      const nextItems = state.items.map((item) => (item.id === action.payload.id ? action.payload : item));
      return { ...state, items: nextItems };
    }
    case PLAYLIST_DELETE: {
      const nextItems = state.items.filter((item) => item.id !== action.payload);
      return { ...state, items: nextItems };
    }

    default:
      return state;
  }
}
